import { Identity, User } from "@core/domains/identity";
import {
  OffsetPaginationSchema,
  adminApi,
  apiEndpoint,
  offsetPaginatedResponse,
} from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

import { ACCOUNT_SERVICE } from "../config/index.ts";

export const accountAdminApi = adminApi(
  { domain: API_DOMAIN, path: `${ACCOUNT_SERVICE.LABEL}/admin` },
  {
    getUsers: apiEndpoint({
      body: OffsetPaginationSchema,
      response: offsetPaginatedResponse(
        z.object(
          { identities: z.array(Identity.schema), user: User.schema },
          {
            identities: "The identities the user signs in with",
            user: "The user",
          },
        ),
      ),
    }),
  },
);
